import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-document-status",
    templateUrl: "./document-status.component.html",
    styleUrls: ["./document-status.component.scss"],
    standalone: false
})
export class DocumentStatusComponent {
  @Input() type: string;
  @Input() title: string;
  @Input() status: string;
  @Input() errorMessage: string = 'Hubo un error con la carga de este documento. Por favor, inténtalo nuevamente.';
  @Output() documentType = new EventEmitter<string>();
  @Output() fileSelected = new EventEmitter<any>();
  @Output() cancelQuery = new EventEmitter<boolean>();
  @Output() deleteDoc = new EventEmitter<any>();
  errorCustomFile = false;

  setDocumentType() {
    this.documentType.emit(this.type);
  }

  onFileSelected(event: any): void {
    const maxSize10Mb = 10000000;
    const file = event.target.files[0];
    if (
      file?.size <= maxSize10Mb &&
      (file?.type === "application/pdf" || file?.type === "image/jpeg")
    ) {
      this.errorCustomFile = false;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64 = e.target.result.split(";base64,");
        const documentType = this.type;
        const payload = {
          documentType,
          fileStringBase64: base64[1],
        };
        this.fileSelected.emit(payload);
      };
      reader.readAsDataURL(file);
    } else {
      this.errorCustomFile = true;
    }
  }

  cancel() {
    this.cancelQuery.emit(true);
  }

  delDocument() {
    let documentType = this.type;
    let payload = { documentType }
    this.deleteDoc.emit( payload );
  }
}
